import { z } from "zod";

export const verifyPasswordPayloadSchema = z.string();

export type VerifyPasswordPayloadType = z.infer<typeof verifyPasswordPayloadSchema>;

